// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2gqiL","amount":"Amount_amount__2xXVl","tip":"Amount_tip__3ZLlk","tipHeader":"Amount_tipHeader__1pYPY","tipsWrap":"Amount_tipsWrap__3Wff7"};